export default __webpack_public_path__ + "static/media/checked-icon.c6fbb06f.svg";